import React from 'react';

import { BaseIconProps } from './';

export const FacebookSquare = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(2.109375,0,0,-2.109375,0,1080)"
    d="M512 457l0-402c0-30-25-55-55-55l-97 0 0 202 69 0 10 78-79 0 0 49c0 23 6 38 38 38l41 0 0 69c-20 2-40 3-60 3-59 0-99-36-99-102l0-57-70 0 0-78 70 0 0-202-225 0c-30 0-55 25-55 55l0 402c0 30 25 55 55 55l402 0c30 0 55-25 55-55z"
    fill={fill}
  />
);
